import GoogleMapReact from "google-map-react";
import { useEffect, useState } from "react";
import LocationMarker from "./LocationMarker";

function ExperienceMap({ locality, city, country,house_no }) {
  const [mapCoordinates, setMapCoordinates] = useState(null);
  const [mapZoom] = useState(14);

  const mapStyle = [
    // { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
    // { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
    // { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      // stylers: [{ color: "#c9b2a6" }],
    },
    {
    featureType: "poi",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }],
  },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      // stylers: [{ color: "#a5b076" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      // stylers: [{ color: "#f5f1e6" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      // stylers: [{ color: "#f8c967" }],
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      // stylers: [{ color: "#b9d3c2" }],
    },
  ];

  const address = `${house_no || ""}, ${locality || ""}, ${city || ""}, ${country || ""}`.trim();
  

  useEffect(() => {
    if (!locality && !city && !country) return;


    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        address
      )}&key=${process.env.REACT_APP_GOOGLE_KEY}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.results && data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          
          setMapCoordinates({ lat, lng });
          
        } else {
          console.warn("No results found for the given address:", address);
        }
      })
      .catch((err) => console.error("Geocoding failed:", err));
  }, [address]);

  // 🧭 If coordinates are not yet available, don’t show the map
  if (!mapCoordinates) {
    return (
      <div
        className="mapss_bx flex items-center justify-center rounded-2xl bg-gray-100 text-gray-500"
        style={{ width: "100%", height: "400px" }}
      >
        Loading map...
      </div>
    );
  }

  return (
    <div
      className="mapss_bx relative rounded-2xl overflow-hidden shadow-lg"
      style={{
        width: "100%",
        height: "400px",
        borderRadius: "20px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      }}
    >
      <GoogleMapReact
        bootstrapURLKeys={{
          key: process.env.REACT_APP_GOOGLE_KEY,
        }}
        center={mapCoordinates}
        zoom={mapZoom}
        yesIWantToUseGoogleMapApiInternals
        options={{
          styles: mapStyle,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: true,
        }}
      >
        <LocationMarker lat={mapCoordinates.lat} lng={mapCoordinates.lng} />
      </GoogleMapReact>
    </div>
  );
}

export default ExperienceMap;
